import {ISavedResponse} from '@src/Api/TraceApi/endpoints/memberDataEndpoint/interface/memberDataResponse.interface';
import useUpdateBookmarks from '@src/Hooks/useUpdateBookmarks';
import {IVodItemFragmentFragment} from '@src/Api/Graphql/gql/types.generated';

export function useVodBookmark(vodItem?: IVodItemFragmentFragment) {
  const {findBookmarkItem, updateBookMark} = useUpdateBookmarks({
    screenSource: 'detail',
  });
  const bookmarkItem: ISavedResponse | undefined = vodItem
    ? findBookmarkItem(vodItem.id)
    : undefined;

  function handleFav(value: boolean) {
    if (vodItem && vodItem.id && vodItem.url) {
      updateBookMark(vodItem.id, vodItem.url, value, {
        id: vodItem.id,
        url: vodItem.url,
        __typename: vodItem.__typename,
        name: vodItem.title,
        categoryName: vodItem.parent?.name,
        raw: vodItem,
      });
    }
  }

  return {bookmarkItem, handleFav};
}
